import { Box } from "@/components/ui/box";
import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { ScrollView } from "react-native-gesture-handler";
import i18n from "i18n-js";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import Footer from "@/components/basic/Footer";
import ContactElement from "@/components/basic/ContactElement";
import useIsMounted from '@/hooks/mounted';
import ModalConfirm from "@/components/basic/ModalConfirm";
import BasicElement from "@/components/basic/BasicElement";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { switchScreen } from '@/hooks/navigate';
import InAInfo from "@/components/basic/InAInfo";

export default function Channels({ navigation, route, updateContactChilds }) {

    const { channels, info, isEdit, isFinal } = route.params
    const user = useSelector((state) => state.user)
    const server = useSelector((state) => state.server)
    const contacts = useSelector((state) => state.contacts)
    const mounted = useIsMounted()
    const insets = useSafeAreaInsets()

    const [actChannels, setActChannels] = useState(channels)
    const [showModal, setShowModal] = useState(false)
    const [action, setAction] = useState()

    const actions = [
        { icon: 'keyboard-arrow-left', text: 'footer.back', component: 'BACK' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        isEdit ? { icon: 'check', text: 'footer.finish', component: 'BACK' } : { icon: '' }
    ]

    const setChannels = (channelId, isSelected) => {
        if (isSelected) {
            setActChannels(prev => {
                const next = [...prev]
                next.push(channelId)
                return next
            })
        } else {
            setActChannels(prev => {
                const next = prev.filter(id => id != channelId)
                return next
            })
        }
    }

    useEffect(
        () => {
            return navigation.addListener('beforeRemove', (e) => {
                if (null == actChannels || !isEdit) {
                    return
                }
                const noneRemoved = channels.filter(channels => !actChannels.includes(channels)).length == 0
                // if there are no deletions
                if (noneRemoved) {
                    return;
                }
                // Prevent default behavior of leaving the screen
                e.preventDefault()
                // Prompt the user before leaving the screen
                setAction(e.data.action)
                setShowModal(true)
            })
        },
        [navigation, actChannels]
    )

    const closeModal = (confirmed) => {
        setShowModal(false)
        if (confirmed) {
            navigation.dispatch(action)
        } else {
            // reset selections
            setActChannels(channels)
        }
    }

    useEffect(() => {
        navigation.setOptions({ title: i18n.t('channel.channels'), info: info || '' })
    }, [])

    useEffect(() => {
        return () => {
            if (!mounted()) {
                if (updateContactChilds) {
                    updateContactChilds(actChannels, null)
                }
            }
        };
    }, [mounted])

     const addChannel = () => {
         switchScreen(navigation, 'Channel', {
             channel: {
                 id: null,
                 name: null,
                 description: null,
                 channelImage: null,
                 contacts: [],
                 workflows: [],
                 createdAt: null,
                 createdBy: {
                     id: user.id
                 },
                 modifiedAt: null
             }, isEdit: true
         })
     }
 
    const buttonAddChannel = { action: addChannel, info: 'contactManagement.addChannel' }
    const showInfo = !isEdit && (actChannels ? actChannels.length : contacts.channels.length) == 0

    return (
        <View className="flex-1 bg-secondary-50">
            {showInfo ? <InAInfo asHint={true} info={i18n.t('channel.noChannels')} pose={5} /> : <>
                <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 70 + insets.bottom }} className="flex-1 bg-secondary-50">
                    <VStack>
                        <Text className="px-3 py-3 text-2xl text-secondary-900">{i18n.t('contactManagement.channels', { num: actChannels ? actChannels.length : contacts.channels.length })}</Text>
                        {isEdit ?
                            contacts.channels.map((channel, index) => <ContactElement
                                key={'A' + index}
                                uri={channel?.channelImage?.id}
                                title={channel.name}
                                text={i18n.t('channel.numcontacts', { num: channel.contacts.length })}
                                onPress={setChannels}
                                id={channel.id}
                                selected={actChannels.includes(channel.id)} />)
                            : isFinal ?
                                contacts.channels.filter(channel => null == actChannels || actChannels.includes(channel.id)).map((channel, index) =>
                                    <Box key={'A' + index} className="px-3">
                                        <BasicElement
                                            media={channel?.channelImage?.id}
                                            sync={'/contact/media/' + channel?.channelImage?.id}
                                            title={channel.name}
                                            text={i18n.t('channel.numcontacts', { num: channel.contacts.length })}
                                        />
                                    </Box>
                                )
                                : contacts.channels.filter(channel => null == actChannels || actChannels.includes(channel.id)).map((channel, index) =>
                                    <ContactElement
                                        key={'A' + index}
                                        uri={channel?.channelImage?.id}
                                        title={channel.name}
                                        text={i18n.t('channel.numcontacts', { num: channel.contacts.length })}
                                        onPress={() => actChannels ? switchScreen(navigation, 'SharedWorkflows', { title: channel.name, info: i18n.t('contact.sharedWorkflows'), channel: channel, isEdit: false }) : switchScreen(navigation, 'Channel', { channel: channel, isEdit: false })} />)
                        }
                    </VStack>
                </ScrollView>
                <ModalConfirm showModal={showModal} closeModal={closeModal} title='shareWorkflow.title' text='shareWorkflow.textContactExclude' buttonOk='shareWorkflow.ok' />
            </>}<Footer navigation={navigation} button={server.online && showInfo ? buttonAddChannel : null} actions={actions} />
        </View>
    );
}